import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 mt-12">
      <div className="container mx-auto px-4 py-8 text-center">
        <p className="text-slate-600 dark:text-slate-300 font-medium">
          Secure payments powered by Stripe. Cancel anytime.
        </p>
        <div className="mt-4 pt-4 border-t border-slate-200 dark:border-slate-700">
          <p className="text-slate-500 dark:text-slate-400">
            © 2026 The Learning Index. All rights reserved.
          </p>
          <p className="text-sm text-slate-400 dark:text-slate-500 mt-2">
            AI Preparation Layer for Education • Built for educators
          </p>
        </div>
      </div>
    </footer>
  );
};
